/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var InfoOctagon = createReactComponent("info-octagon", "InfoOctagon", [["path", { "d": "M7.805 3.469C8.16 3.115 8.451 3 8.937 3h6.126c.486 0 .778.115 1.132.469l4.336 4.336c.354.354.469.646.469 1.132v6.126c0 .5-.125.788-.469 1.132l-4.336 4.336c-.354.354-.646.469-1.132.469H8.937c-.5 0-.788-.125-1.132-.469L3.47 16.195c-.355-.355-.47-.646-.47-1.132V8.937c0-.5.125-.788.469-1.132z", "key": "svg-0" }], ["path", { "d": "M12 16v-5h-.5m0 5h1M12 8.5V8", "key": "svg-1" }]]);

export { InfoOctagon as default };
//# sourceMappingURL=InfoOctagon.js.map
